/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import { object, func } from 'prop-types';
import { TextField } from '@material-ui/core';
import searchicon from '../Assets/searchicon.svg';
import useDebounce from '../../../../../../../helpers/hooks/useDebounce';

const SearchFilter = ({ recipientState, setFilteredRecipients, resetVisibleRecipientsCount }) => {
    const [searchValue, setSearchValue] = useState('');
    const { addressBookResponse } = recipientState;
    const debouncedSearchValue = useDebounce(searchValue, 500);
    const filterRecipientData = () => {
        resetVisibleRecipientsCount();

        const filteredRecipientsByName = addressBookResponse?.addressList?.filter((recipient) => {
            if ((recipient?.rcpFirstName && recipient?.rcpLastName) || recipient?.rcpEmployerName) {
                const { rcpFirstName, rcpLastName, rcpEmployerName } = recipient;
                return rcpFirstName?.toLowerCase().includes(searchValue.toLowerCase())
                    || rcpLastName?.toLowerCase().includes(searchValue.toLowerCase())
                    || (`${rcpFirstName} ${rcpLastName}`).toLowerCase().includes(searchValue.toLocaleLowerCase())
                    || rcpEmployerName?.toLowerCase().includes(searchValue.toLocaleLowerCase())
            }
            return [];
    });
        setFilteredRecipients({ addressBookResponse: { ...addressBookResponse, addressList: filteredRecipientsByName, totalEntries: filteredRecipientsByName.length } });
    };

    useEffect(() => {
        if (debouncedSearchValue) {
            filterRecipientData();
        } else {
            resetVisibleRecipientsCount();
            setFilteredRecipients({}); 
        }
    }, [debouncedSearchValue]);

    return (
        <>
            <TextField placeholder="Contact Name" fullWidth variant="outlined" onChange={(e) => setSearchValue(e.target.value)} />
            <img alt="search icon" src={searchicon} />
        </>
    );
};

SearchFilter.propTypes = {
    recipientState: object.isRequired,
    setFilteredRecipients: func.isRequired,
};

export default SearchFilter;
